import { apiRequest } from './client'

export interface AcademyNotification {
  id: number
  event_type: string
  audience: 'global' | 'personal' | 'system'
  title: string
  body: string
  image_url: string | null
  target_url: string | null
  created_at: string
  is_read: boolean
}
export interface NotificationFeed {
  unread_count: number
  items: AcademyNotification[]
}
export interface NotificationPreferences {
  sound_enabled: boolean
  sound_volume: number
  global_enabled: boolean
}
export const fetchNotifications = () => apiRequest<NotificationFeed>('/api/v1/notifications?limit=30')
export const fetchNotificationPreferences = () => apiRequest<NotificationPreferences>('/api/v1/notifications/preferences')
export const saveNotificationPreferences = (value: NotificationPreferences) => apiRequest<NotificationPreferences>('/api/v1/notifications/preferences', {method:'PUT', body:JSON.stringify(value)})
export const markNotificationRead = (id:number) => apiRequest<{success:boolean}>(`/api/v1/notifications/${id}/read`, {method:'POST'})
export const markAllNotificationsRead = () => apiRequest<{success:boolean}>('/api/v1/notifications/read-all', {method:'POST'})
